module.exports = __webpack_public_path__ + "img/ambassadeur.3c71b9fa.svg";